import { render, staticRenderFns } from "./SponsorManagement.vue?vue&type=template&id=5b1bb19c&scoped=true"
import script from "./SponsorManagement.vue?vue&type=script&lang=js"
export * from "./SponsorManagement.vue?vue&type=script&lang=js"
import style0 from "./SponsorManagement.vue?vue&type=style&index=0&id=5b1bb19c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1bb19c",
  null
  
)

export default component.exports